import SummaryCardRootComponent from './SummaryCardRoot.component';

export default SummaryCardRootComponent;
